
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/tutorials/publish-download-files-dexp2p",
      function () {
        return require("private-next-pages/docs/smart-chains/tutorials/publish-download-files-dexp2p/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/tutorials/publish-download-files-dexp2p"])
      });
    }
  